import { EVENT_NAME, SCHEMA_NAME, SOURCES } from '../constants/tracking';

import type { Source, Action, Component, Provider, StepName } from '../types';
import type { GrapplerEvent } from '@web-platform/global-components-utils/tracking';

type LoginWebEventMessage = {
  action?: Action;
  action_id?: string;
  component?: Component;
  experiment_context?: string;
  microsite?: string;
  provider?: Provider;
  screen_name?: string;
  source?: Source;
  step_name: StepName;
};

/**
 * TODO(CAPY-2362): remove once `TRIP` is added to the external `login_web_event` proto schema.
 * Until then, `TRIP` is downgraded to `OTHER` on the wire so real events aren't sent with an
 * enum value the schema/data pipeline doesn't recognise yet. `FeatureImage`'s image selection
 * and the `TRIPS_LoginTitle`/`TRIPS_LoginSubtitle` copy overrides are unaffected — they read the
 * original `source`/referrer before it reaches this function.
 */
const toWireSource = (source?: Source): Source | undefined =>
  source === SOURCES.TRIP ? SOURCES.OTHER : source;

const loginWebTrackingEvent = (message: LoginWebEventMessage): [GrapplerEvent] => [
  {
    topic: 'grappler-track',
    data: {
      eventName: EVENT_NAME,
      fullSchemaName: `${SCHEMA_NAME}.${EVENT_NAME}`,
      message: { ...message, source: toWireSource(message.source) },
      isMiniEvent: true,
      consentRequired: true,
    },
  },
];

export { loginWebTrackingEvent };
